<template>
  <div class="management-bd partner-contract">
    <div class="management-wrap">
      <el-radio-group v-model="tabActive" class="radio-group">
        <el-radio-button :label="item.value" v-for="(item, index) in tabType" :key="index">{{ item.label }}</el-radio-button>
      </el-radio-group>
      <!-- 统计 -->
      <template v-if="tabActive === 1">
        <div class="count-box">
          <div class="titel"></div>
          <div class="chart-coontract" ref="pie"></div>
        </div>
      </template>
      <!-- 列表 -->
      <template v-if="tabActive === 2">
        <div class="search-hd">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <!--
              试用订单-10
              租赁合同-20
              续租合同-21
              试用转租赁-22
              框架合同-30
              协议订单-31
              E类购-41
              新机购-42
              租转售-43
              租售订单-40
              自定义
              库存调拨-100
              code="crm_contract_type"
            -->
              <custom-select v-model="formSearch.contractClassSelf" :data="contractClassList" :auto="false" width="100%" @change="onContractClass"></custom-select>
              <!--  -->
            </el-form-item>
            <!-- 配置项 -->
            <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item>
            <!-- 搜索项 -->
            <el-form-item style="float: right">
              <search-input
                v-if="`${formSearch.contractClassSelf}` !== '100'"
                :placeholder="$t('crm_partner-contract.qsrhtbh')"
                v-model="formSearch.search"
                clearable
                @fetch="onPageChange({ page: 1 })"
                style="width: 280px"
              ></search-input>
              <!--库存调拨-->

              <search-input v-else v-model="formSearch.search" :placeholder="$t('crm_partner-contract.kcfckftbdh')" @fetch="onPageChange({ page: 1 })"></search-input>
            </el-form-item>
            <el-form-item style="float: right">
              <!-- 租赁 协议订单 -->
              <switch-button v-if="`${formSearch.contractClassSelf}` === '20' || `${formSearch.contractClassSelf}` === '31'" :link="$refs.container"></switch-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 租赁和框架合同 -->
        <switch-container v-if="`${formSearch.contractClassSelf}` === '20'" ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
          <el-form :inline="true" label-position="top">
            <!-- 租赁方 -->
            <el-form-item :label="$t('crm_partner-contract.zu_lin_fang')" v-if="userInfo && userInfo.bizType === 'CO'">
              <!-- type
            <! --
              orgType
              总部:HQ
              售后公司:SC
              代理公司:JV
              服务公司:JV_SC
              大客户:CO
              租赁方:CS
            type
              1-租赁合同+框架协议 2-协议订单 3-试用订单  -->
              <el-input v-model="formSearch.customerName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
            <!-- 售后公司 -->
            <el-form-item :label="$t('crm_partner-contract.shou_hou_gong_si')">
              <el-input v-model="formSearch.afterServiceName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
            <!-- 甲方授权代表 -->
            <el-form-item :label="$t('crm_partner-contract.jfsqdb')">
              <el-input v-model="formSearch.partAName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
            <!-- 提交日期 -->
            <el-form-item :label="$t('crm_partner-contract.ti_jiao_ri_qi')">
              <custom-date-picker
                v-model="formSearch.submitTime"
                type="daterange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionDisAfter"
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>
            <!-- 签订日期 -->
            <el-form-item :label="$t('crm_partner-contract.qian_ding_ri_qi')">
              <custom-date-picker
                v-model="formSearch.signingTime"
                type="daterange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionDisAfter"
                unlink-panels
                range-separator="——"
                start-placeholder=""
                end-placeholder=""
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>
            <!-- 生效时间 -->
            <el-form-item :label="$t('crm_partner-contract.sheng_xiao_shi_jian')">
              <custom-date-picker
                v-model="formSearch.effectiveDate"
                type="daterange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionDisAfter"
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>
            <!-- 项目名称 -->
            <el-form-item :label="$t('crm_partner-contract.xiang_mu_ming_cheng')">
              <el-input v-model="formSearch.locationName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
          </el-form>
        </switch-container>
        <!--协议 -->
        <switch-container v-else-if="`${formSearch.contractClassSelf}` === '31'" ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
          <el-form :inline="true" label-position="top">
            <!-- 租赁方 -->
            <el-form-item :label="$t('crm_partner-contract.zu_lin_fang')" v-if="userInfo && userInfo.bizType === 'CO'">
              <!--
              orgType
              总部:HQ
              售后公司:SC
              代理公司:JV
              服务公司:JV_SC
              大客户:CO
              租赁方:CS
            type
              1-租赁合同+框架协议 2-协议订单 3-试用订单  -->
              <el-input v-model="formSearch.customerName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
            <!-- 售后公司 -->
            <el-form-item :label="$t('crm_partner-contract.shou_hou_gong_si')">
              <el-input v-model="formSearch.afterServiceName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
            <!-- 甲方授权代表 -->
            <el-form-item :label="$t('crm_partner-contract.jfsqdb')">
              <el-input v-model="formSearch.partAName" :placeholder="i18n.com_please_input"></el-input>
            </el-form-item>
            <!-- 提交日期 -->
            <el-form-item :label="$t('crm_partner-contract.ti_jiao_ri_qi')">
              <custom-date-picker
                v-model="formSearch.submitTime"
                type="daterange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionDisAfter"
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>
            <!-- 签订日期 -->
            <el-form-item :label="$t('crm_partner-contract.qian_ding_ri_qi')">
              <custom-date-picker
                v-model="formSearch.signingTime"
                type="daterange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionDisAfter"
                unlink-panels
                range-separator="——"
                start-placeholder=""
                end-placeholder=""
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>
            <!-- 生效时间 -->
            <el-form-item :label="$t('crm_partner-contract.sheng_xiao_shi_jian')">
              <custom-date-picker
                v-model="formSearch.effectiveDate"
                type="daterange"
                align="right"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionDisAfter"
                style="width: 100%"
              ></custom-date-picker>
            </el-form-item>
          </el-form>
        </switch-container>
        <div class="table-bd">
          <!-- 租赁和框架合同 -->
          <custom-table
            v-if="`${formSearch.contractClassSelf}` === '20'"
            ref="tb1"
            height="100%"
            tableCode="contract_list"
            v-loading="isLoading"
            :data="contractList"
            :column="tableColumn"
            :index="true"
            :filterArr="['action']"
            :slots="['contractNo', 'customContractNo', 'productDetail']"
            @filter="filterChange"
            @column="setColumn"
            columnRef="column"
            @sort="sortChange"
          >
            <template v-slot:contractNo="scope">
              <div
                v-if="baseFuncView.contract_info_watch"
                class="cell-link"
                @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
              >
                {{ scope.row.contractNo }}
              </div>
              <span v-else>
                {{ scope.row.contractNo }}
              </span>
            </template>
            <template v-slot:customContractNo="scope">
              <div
                v-if="baseFuncView.contract_info_watch"
                class="cell-link"
                @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
              >
                {{ scope.row.customContractNo }}
              </div>
              <span v-else>
                {{ scope.row.contractNo }}
              </span>
            </template>
            <!-- v-if="scope.row.bizClass === '30'" -->
            <template v-slot:productDetail="scope">
              <el-popover placement="bottom" width="420" trigger="hover" v-if="scope.row.goodsCountList">
                <el-table :data="scope.row.goodsCountList">
                  <el-table-column width="100" property="productCode" :label="$t('crm_partner-contract.xing_hao')"></el-table-column>
                  <el-table-column width="70" property="deviceBizType" :label="$t('crm_partner-contract.she_bei_lei_xing')"></el-table-column>
                  <el-table-column width="70" property="bookingNum" :label="$t('crm_partner-contract.shu_liang')"></el-table-column>
                  <el-table-column width="70" property="rentalTerm" :label="$t('crm_partner-contract.zu_lin_yue_shu')"></el-table-column>
                  <el-table-column width="70" property="unitPrice" :label="$t('crm_partner-contract.zu_jin_yue')"></el-table-column>
                </el-table>
                <!-- <contract-list-table
                :data="scope.row.goodsCountList"
              ></contract-list-table> -->
                <el-button slot="reference" type="text">{{ $t('crm_partner-contract.cksbxq') }}</el-button>
              </el-popover>
              <el-button v-else type="text">{{ $t('crm_partner-contract.cksbxq') }}</el-button>
            </template>
            <!-- </el-table-column> -->
          </custom-table>
          <!-- 协议订单 -->
          <custom-table
            v-else-if="`${formSearch.contractClassSelf}` === '31'"
            ref="tb1"
            height="100%"
            v-loading="isLoading"
            :data="contractList"
            tableCode="contract_order"
            :index="true"
            :filterArr="['action']"
            :slots="['contractNo', 'orderCode', 'customContractNo', 'productDetail']"
            @filter="filterChange"
            @sort="sortChange"
            @column="setColumn"
          >
            <template v-slot:contractNo="scope">
              <div
                v-if="baseFuncView.agreement_order_watch"
                class="cell-link"
                @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
              >
                {{ scope.row.contractNo }}
              </div>
              <span v-else>{{ scope.row.contractNo }}</span>
            </template>
            <template v-slot:orderCode="scope">
              <div
                v-if="baseFuncView.agreement_order_watch"
                class="cell-link"
                @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
              >
                {{ scope.row.orderCode }}
              </div>
              <span v-else>{{ scope.row.orderCode }}</span>
            </template>
            <template v-slot:customContractNo="scope">
              <div
                v-if="baseFuncView.agreement_order_watch"
                class="cell-link"
                @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
              >
                {{ scope.row.customContractNo }}
              </div>
              <span v-else>{{ scope.row.customContractNo }}</span>
            </template>
            <template v-slot:productDetail="scope">
              <el-popover placement="bottom" width="340" trigger="hover" v-if="scope.row.goodsCountList">
                <el-table :data="scope.row.goodsCountList">
                  <el-table-column width="100" property="productCode" :label="$t('crm_partner-contract.xing_hao')"></el-table-column>
                  <el-table-column width="70" property="bookingNum" :label="$t('crm_partner-contract.shu_liang')"></el-table-column>
                  <el-table-column width="70" property="rentalTerm" :label="$t('crm_partner-contract.zu_lin_yue_shu')"></el-table-column>
                  <el-table-column width="70" property="unitPrice" :label="$t('crm_partner-contract.zu_jin_yue')"></el-table-column>
                </el-table>
                <!-- <contract-list-table
                  :data="scope.row.goodsCountList"
                ></contract-list-table> -->
                <!-- <el-button slot="reference" type="text">{{ $t('p_partnerDetail_cksbxq') }}</el-button> -->
                <el-button slot="reference" type="text">{{ $t('crm_partner-contract.cksbxq') }}</el-button>
              </el-popover>
              <el-button v-else type="text">{{ $t('crm_partner-contract.cksbxq') }}</el-button>
            </template>
          </custom-table>
          <!-- 试用 -->
          <custom-table
            v-else-if="`${formSearch.contractClassSelf}` === '10'"
            ref="tb1"
            height="100%"
            v-loading="isLoading"
            :data="contractList"
            tableCode="try_order_list"
            :index="true"
            :filterArr="['action']"
            :slots="['orderCode', 'productDetail']"
            @filter="filterChange"
            @sort="sortChange"
            @column="setColumn"
          >
            <template v-slot:orderCode="scope">
              <div
                v-if="baseFuncView.trial_order_manage_detail"
                class="cell-link"
                @click="jump('/contractdetail', { contractId: scope.row.bizId, contractClass: scope.row.bizClass, parentPath: $route.path })"
              >
                {{ scope.row.orderCode }}
              </div>
              <span v-else>{{ scope.row.orderCode }}</span>
            </template>
            <template v-slot:productDetail="scope">
              <el-popover placement="bottom" width="270" trigger="hover" v-if="scope.row.goodsCountList">
                <el-table :data="scope.row.goodsCountList">
                  <el-table-column width="100" property="productCode" :label="$t('crm_partner-contract.xing_hao')"></el-table-column>
                  <el-table-column width="70" property="bookingNum" :label="$t('crm_partner-contract.shu_liang')"></el-table-column>
                  <el-table-column width="70" property="rentalTerm" :label="$t('crm_partner-contract.tian_shu')"></el-table-column>
                </el-table>
                <el-button slot="reference" type="text">{{ $t('crm_partner-contract.cksbxq') }}</el-button>
              </el-popover>
              <el-button v-else type="text">{{ $t('crm_partner-contract.cksbxq') }}</el-button>
            </template>
          </custom-table>
          <!-- 调拨 -->
          <custom-table
            v-else
            height="100%"
            :data="contractList"
            tableCode="contract_inventory_picking"
            :index="true"
            @filter="filterChange"
            @sort="sortChange"
            @column="setColumn"
            :filterArr="['action']"
            :slots="['detail']"
          >
            <template v-slot:detail="scope">
              <div>
                <el-tooltip placement="top" v-if="scope.row.goodsList && scope.row.goodsList.length">
                  <div slot="content">
                    <table style="width: 200px; line-height: 30px">
                      <thead>
                        <th>{{ i18n.label_product_code }}</th>
                        <th>{{ i18n.label_num }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in scope.row.goodsList" :key="index">
                          <td style="text-align: center">{{ item.productCode }}</td>
                          <td style="text-align: center">{{ item.bookingNum }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <el-button type="text" size="mini">{{ i18n.page_content_device_detail }}</el-button>
                </el-tooltip>
              </div>
            </template>
          </custom-table>
        </div>
        <div class="table-page">
          <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import G2 from 'G2';
import DataSet from '@antv/data-set';
import insertCss from 'insert-css';
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import moment from 'moment';

insertCss(`
    .pie-guide-html {
        width: 100px;
        height: 80px;
        vertical-align: middle;
        text-align: center;
        line-height: 0.2;
    }

    .pie-guide-html .title {
        font-size: 12px;
        color: #8c8c8c;
        font-weight: 300;
    }

    .pie-guide-html .value {
        font-size: 12px;
        color: #000;
        font-weight: bold;
        padding-left: 10px;
    }
`);
export default {
  components: {},
  mixins: [resetFormSearchMixins],
  props: ['partnerId', 'partnerType'],
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractClassSelf: '',
        contractClass: [],
        partnerId: '',

        customerName: '',
        afterServiceName: '',
        partAName: '',
        signingTime: '',
        signingStartDate: '', // 签订开始日期
        signingEndDate: '', // 签订结束日期
        submitTime: '',
        submitStartDate: '', // 创建开始时间
        submitEndDate: '', // 创建开始时间
        effectiveDate: '',
        effectiveStartDate: '', // 生效开始时间
        effectiveEndDate: '', // 生效开始时间
        locationName: '',
      },
      dataTimes: [],
      totalRows: null,
      isLoading: false,

      contractList: [],

      contractCount: [],
      // 合同类型

      // 操作
      visibleSet: '',
      dialogSetData: {},
      tabActive: 2,
    };
  },
  mounted() {

    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();
    // this.getContract();
  },
  computed: {
    tabType() {
      return [
        {
          label: this.$t('crm_partner-contract.tong_ji'),
          value: 1,
        },
        {
          label: this.$t('crm_partner-contract.lie_biao'),
          value: 2,
        },
      ];
    },
    contractTypeList() {
      // 1.纸质合同、2.电子合同、3.大客户协议、4.库存调拨单、5.协议订单、6.续租合同
      const paperContract = {
        name: this.$t('crm_partner-contract.zhi_zhi_he_tong'),
        value: '1',
      };
      const electronicContract = {
        name: this.$t('crm_partner-contract.dian_zi_he_tong'),
        value: '2',
      };
      const customerAgreement = {
        name: this.$t('crm_partner-contract.da_ke_hu_xie_yi'),
        value: '3',
      };
      const inventoryOrder = {
        name: this.$t('crm_partner-contract.ku_cun_tiao_bo_dan'),
        value: '4',
      };
      const agreementOrder = {
        name: this.$t('crm_partner-contract.xie_yi_ding_dan'),
        value: '5',
      };
      const renewContract = {
        name: this.$t('crm_partner-contract.xu_zu_he_tong'),
        value: '6',
      };
      return [paperContract, electronicContract, customerAgreement, inventoryOrder, agreementOrder, renewContract];
    },

    contractClassList() {
      const leasingContract = {
        name: this.$t('crm_partner-contract.zu_lin_he_tong'),
        value: '20',
        langRouter: '/contract/management',
      };
      const frameworkOrder = {
        name: this.$t('crm_partner-contract.xie_yi_ding_dan'),
        value: '31',
        langRouter: '/contract/agreementOrder',
      };
      const stockContract = {
        name: this.$t('crm_partner-contract.ku_cun_tiao_bo'),
        value: '100',
        langRouter: '/crmStock/contractInventoryPicking',
      };
      const trialContract = {
        name: this.$t('crm_partner-contract.shi_yong_ding_dan'),
        value: '10',
        langRouter: '/contract/trialOrder',
      };

      if (`${this.partnerType}` === 'HQ') {
        // 个人租赁方
        return [leasingContract, frameworkOrder, stockContract, trialContract];
      } else if (`${this.partnerType}` === 'SC' || `${this.partnerType}` === 'JV' || `${this.partnerType}` === 'JV_SC') {
        return [leasingContract, stockContract, trialContract];
      } else if (`${this.partnerType}` === 'CS') {
        return [leasingContract, frameworkOrder];
      }
      return [];
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    contractClassList: {
      // 深度监听，可监听到对象、数组的变化
      handler(val) {
        this.formSearch.contractClassSelf = val[0].value;
        // this.getContract();
        this.formSearch.submitTime = [this.$momentWorld(moment().startOf('month')), this.$momentWorld(moment().endOf('day'))];
        this.onContractClass(val[0]);
      },
      immediate: true,
      deep: true, // true 深度监听
    },
    tabActive: {
      // 深度监听，可监听到对象、数组的变化
      handler(val) {
        if (val === 1) {
          // 获取合同统计
          this.getContractCount();
        }
      },
      immediate: true,
    },
  },
  methods: {
    getContract: function () {
      this.formSearch.partnerId = this.partnerId;
      this.formSearch.contractClass = [this.contractClassSelf];
      this.isLoading = true;
      this.formSearch.signingStartDate = this.formSearch.signingTime && this.formSearch.signingTime[0] ? this.formSearch.signingTime[0] : undefined;
      this.formSearch.signingEndDate = this.formSearch.signingTime && this.formSearch.signingTime[1] ? this.formSearch.signingTime[1] : undefined;
      this.formSearch.submitStartDate = this.formSearch.submitTime && this.formSearch.submitTime[0] ? this.formSearch.submitTime[0] : undefined;
      this.formSearch.submitEndDate = this.formSearch.submitTime && this.formSearch.submitTime[1] ? this.formSearch.submitTime[1] : undefined;
      this.formSearch.effectiveStartDate = this.formSearch.effectiveDate && this.formSearch.effectiveDate[0] ? this.formSearch.effectiveDate[0] : undefined;
      this.formSearch.effectiveEndDate = this.formSearch.effectiveDate && this.formSearch.effectiveDate[1] ? this.formSearch.effectiveDate[1] : undefined;
      let requestApi = '';
      // 租赁和框架
      if (`${this.formSearch.contractClassSelf}` === '20') {
        requestApi = apis.contractList4Partner;
      } else if (`${this.formSearch.contractClassSelf}` === '31') {
        // 协议
        requestApi = apis.crmContractOrderPage;
      } else if (`${this.formSearch.contractClassSelf}` === '10') {
        // 试用
        requestApi = apis.trialOrderPage;
      } else {
        // 调拨单
        requestApi = apis.transferOrderPage;
      }
      this.$getJSON(requestApi, this.formSearch).then((res) => {
        this.isLoading = false;
        this.contractList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getContractCount: function () {
      this.$getJSON(`${apis.contractCount4Partner}/${this.partnerId}`).then((res) => {
        this.contractCount = res.data || [];
        this.drawPie();
      });
    },

    // 饼图
    drawPie() {
      const data = this.contractCount.map((i) => {
        const obj = { ...i };
        const contractType = this.contractTypeList.find(t => `${t.value}` === `${i.type}`);
        obj.type = `${contractType.name} ${i.num} (${i.percent})`;
        return obj;
      });

      // const sum = this.contractCount.reduce((total, item) => total + Number(item.num || 0), 0);
      const ds = new DataSet();
      const dv = ds.createView().source(data);

      const chart = new G2.Chart({
        container: this.$refs.pie,
        forceFit: true,
        height: 500,
        // width: 300,
        padding: 'auto',
      });
      chart.source(dv);
      chart.tooltip(false);
      chart.legend({
        position: 'right-center',
        offsetX: -200,
        offsetY: 10,
        itemMarginBottom: 20,
      });
      chart.coord('theta', {
        radius: 0.75,
        innerRadius: 0.73,
      });
      chart
        .intervalStack()
        .position('num')
        .color('type', ['rgba(0, 146, 225, 0.85)', 'rgba(46, 199, 201, 0.85)', 'rgba(178,212,59, 0.85)', 'rgba(253,206,64, 0.85)', 'rgba(0,174,239, 0.85)', 'rgba(104,124,242, 0.85)'])
        .opacity(1)
        .style({
          stroke: 'white',
          lineWidth: 1,
        })
        .label('num', {
          offset: -18,
          textStyle: {
            fill: 'white',
            fontSize: 12,
            shadowBlur: 2,
            shadowColor: 'rgba(0, 0, 0, .45)',
          },
          rotate: 0,
          autoRotate: false,
          formatter: () => '',
        });
      // chart.guide();
      // chart.guide().html({
      //   position: ['86%', '25%'],
      //   html: `<div class="pie-guide-html"><span class="title">${this.i18n.com_all}</span><span class="value">${sum}</span></div>`,
      // });

      chart.render();
    },
    onContractClass(item) {
      if (item) {
        // 没有合并的权限在baseFuncView里  本页面直接用baseFuncView
        this.getFuncView(item.langRouter);
      }
      this.onPageChange({ page: 1 });
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getContract();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.partner-contract {
  height: 100%;
  display: flex;
  flex-direction: column;
  .management-wrap {
    flex: 1;
    // height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;

    .radio-group {
      padding-top: 16px;
      padding-bottom: 14px;
      overflow: hidden;
    }

    .count-box {
      height: 100%;
      width: 100%;
      background: #fff;
      position: relative;
      .chart-pie {
        overflow: hidden;
        position: relative;
        left: -68px;
        top: 48px;
      }
    }
    .morebtn {
      color: $main-color;
    }
  }
}
</style>
